import plPL from "date-fns/esm/locale/pl/index.js";
const datePlPL = {
  name: 'pl-PL',
  locale: plPL
};
export default datePlPL;